import { useDappFilesContext } from "./contexts/DappFilesContext";
import FileExplorerSection from "./sections/FileExplorerSection";
import CompilerSection from "./sections/CompilerSection";
import DeploySection from "./sections/DeploySection";
import SourceControlSection from "./sections/SourceControlSection";

const Sections = () => {
  const { activeSection } = useDappFilesContext();

  if (activeSection === "editor") return <FileExplorerSection />;
  if (activeSection === "compiler") return <CompilerSection />;
  if (activeSection === "deploy") return <DeploySection />;
  if (activeSection === "source-controll") return <SourceControlSection />;

  return null;
};

export default Sections;
